import { AppButton } from "@/components/teacher/AppButton";
import { LibraryBrowser } from "@/components/teacher/LibraryBrowser";
import { TeacherPage } from "@/components/teacher/TeacherPage";
import { useT } from "@/i18n";
import { useNavigate } from "@tanstack/react-router";

export function TeacherBooksPage() {
  const navigate = useNavigate();
  const t = useT();

  return (
    <TeacherPage
      title={t["books.title"]}
      actions={
        <AppButton tone="glass" onClick={() => navigate({ to: "/teacher" })}>
          {t["common.back"]}
        </AppButton>
      }
    >
      <div className="app-card p-5">
        <LibraryBrowser
          onOpenLesson={(lesson) =>
            navigate({
              to: "/teacher/books/lessons/$lessonId",
              params: { lessonId: lesson.id },
            })
          }
        />
      </div>
    </TeacherPage>
  );
}
